// US Map (found on generic and most provider index pages)
const init = () => {
    /* eslint-disable */
    const simplemaps_usmap = {};

    $(document).ready(() => {
        function mapLoader() {
            setTimeout(() => {
                // wait for simplemaps to load into DOM
                const simplemaps_usmap = window.simplemaps_usmap;

                // only load map if our viewport falls within 'medium' breakpoint
                if (
                    Foundation.MediaQuery.atLeast('medium') &&
                    typeof simplemaps_usmap === 'object'
                ) {
                    simplemaps_usmap.load();
                } else {
                    mapLoader();
                }
            }, 500);
        }
        mapLoader();
    });
    /* eslint-enable */
};

export { init };
